import eAdminUserRole from "~/enums/eAdminUserRole"
import { IAdminUser } from "../interfaces/AdminUserInterface"

export const getDefaultValues = (selectedUser: IAdminUser | undefined) => ({
  firstName: selectedUser?.first_name || "",
  lastName: selectedUser?.last_name || "",
  email: selectedUser?.email || "",
  role: selectedUser?.role || eAdminUserRole.Admin,
  selectedCampIds: selectedUser?.camps?.map((camp) => camp.id).filter(Boolean) || [],
})
